export const SET_ADDRESS_BLOCK_SECTION_QUERY = "SET_ADDRESS_BLOCK_SECTION_QUERY";
export const FETCH_ADDRESS_SUBURB_REQUEST = "FETCH_ADDRESS_SUBURB_REQUEST";
export const FETCH_ADDRESS_SUBURB_SUCCESS = "FETCH_ADDRESS_SUBURB_SUCCESS";
export const FETCH_ADDRESS_SUBURB_ERROR = "FETCH_ADDRESS_SUBURB_ERROR";

export const setAddressSectionBlockQuery = (query) => {
    return {type: SET_ADDRESS_BLOCK_SECTION_QUERY, payload: {query}}
};
export const fetchSuburbs = () => {
    return {
        type: 'CALL_API',
        types: [FETCH_ADDRESS_SUBURB_REQUEST, FETCH_ADDRESS_SUBURB_SUCCESS, FETCH_ADDRESS_SUBURB_ERROR],
        path: `api/suburbs`,
        payload: {}
    };
}


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/addressblocksection.js